import React, { useState, useContext } from 'react'
import { Navigate } from 'react-router-dom'
import Button from '../../components/Button/Button'
import ChangeName from './ChangeName/ChangeName'
import ChangeEmail from './ChangeEmail/ChangeEmail'

import AppContext from '../../contexts/AppContext'

import './Profile.css'
import '../../styles/parchment-page.css'
import ChangePassword from './ChangePassword/ChangePassword'

export default function () {
  const { user } = useContext(AppContext)
  if (!user) {
    return <Navigate to="/entrar" />
  }
  const [isNameOpen, setNameOpen] = useState(false)
  const [isEmailOpen, setEmailOpen] = useState(false)
  const [isPasswordOpen, setPasswordOpen] = useState(false)

  return (
    <div className="page parchment-scope">
      <span className="page__eyebrow">帳 · Perfil</span>
      <h1 className="page__title">Perfil</h1>
      <div className="page__panel">
        <div className="profile__buttons">
          <Button type="button" onClick={() => setNameOpen(true)}>
            Cambiar nombre
          </Button>
          <Button type="button" onClick={() => setEmailOpen(true)}>
            Cambiar email
          </Button>
          <Button type="button" onClick={() => setPasswordOpen(true)}>
            Cambiar contraseña
          </Button>
        </div>
      </div>

      <ChangeName isOpen={isNameOpen} onClose={() => setNameOpen(false)} />
      <ChangeEmail isOpen={isEmailOpen} onClose={() => setEmailOpen(false)} />
      <ChangePassword isOpen={isPasswordOpen} onClose={() => setPasswordOpen(false)} />
    </div>
  )
}
